import styled from 'styled-components'

export const Card = styled.div`
	padding: 1rem;
	background: #fff;
	height: 100%;
`
